import { Container } from "reactstrap";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";

interface Props {
    title: string;
}

const HeaderBox = ({
   title,
}: Props) => (
    <Container fluid className="mt-4 d-flex justify-content-between">
        <Breadcrumbs title={title} />
    </Container>
);

export default HeaderBox;
